module.exports = __webpack_public_path__ + "fonts/6bda2894da15af1b1eb4877e1aa49b73-SocialBrands-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SocialBrands-Regular.eot
// module id = 130
// module chunks = 0